import LogoSquared from './logo-squared'
import LogoWithText from './logo-with-text'

const Squared = LogoSquared
const WithText = LogoWithText

const Logo = {
  Squared,
  WithText,
}

export default Logo
